import { createRouter, RouterProvider } from '@tanstack/react-router'
import { QueryProvider } from './providers/QueryProvider'
import { AuthProvider, useAuth } from './providers/AuthProvider'
import { ThemeProvider } from './providers/ThemeProvider'
import { PostHogProvider } from './providers/PostHogProvider'
import { ReloadPrompt } from './components/common/ReloadPrompt'
import { ErrorBoundary } from './components/common/ErrorBoundary'
import { routeTree } from './routeTree.gen'

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  context: {
    auth: undefined!,
  },
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

function InnerApp() {
  const auth = useAuth()
  return <RouterProvider router={router} context={{ auth }} />
}

export function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <ReloadPrompt />
        <QueryProvider>
          <PostHogProvider>
            <AuthProvider>
              <InnerApp />
            </AuthProvider>
          </PostHogProvider>
        </QueryProvider>
      </ThemeProvider>
    </ErrorBoundary>
  )
}
